import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
const backend = await new Backend().init();

export default function StatusButton({
  user_id,
  label,
  user_label,
  user_status,
  fetchUsers: newfetchUsers,
  reload,
  userType
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [activeStatus, setActiveStatus] = useState(user_status || 0);

  /** 🔹 Fetch Users */
  const fetchUsers = useCallback(async () => {
    setIsLoading(true);
    try {
      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        user_id,
        token: localStorage.getItem("token"),
        username: localStorage.getItem("username"),
      };

      const response = await backend.load_user_select(payload);

      if (response.error === "False") {
        setActiveStatus(response?.user?.[user_label] ?? 0);
        if (reload) newfetchUsers();
      } else if (response.logout === 1) {
        window.LogOut();
      } else {
        toast.error(response.message);
      }
    } catch {
      toast.error("Network Error, Failed to fetch user data.");
    } finally {
      setIsLoading(false);
    }
  }, [user_id, user_label, newfetchUsers]);

  /** 🔹 Toggle Limit */
  const handleLimit = useCallback(async () => {
    if (!user_label) {
      toast.error("Label cannot be empty");
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      status_id: user_id,
      type: user_label,
      status: activeStatus === 1 ? 0 : 1,
    };

    try {
      const response = await backend.update_status(payload);
      if (response.error === "False") {
        toast.success(response.message);
        fetchUsers();
      } else {
        toast.error(response.message);
      }
    } catch {
      toast.error("Network Error, Failed to update user.");
    } finally {
      setIsLoading(false);
    }
  }, [activeStatus, fetchUsers, user_id, user_label]);

  const baseStyle =
    "relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80";

  const activeStatusColor =
    activeStatus === 0 ? "bg-[var(--sell)]" : "bg-[var(--buy)]";

  return (
    <div onClick={() => (userType === 5 || userType === 6) ? toast.error("Permission Not Allowed.") :  isLoading ? null : handleLimit()}>
      <div
        style={{
          opacity: isLoading ? 0.6 : 1,
        }}
        className={`${baseStyle} ${activeStatusColor} text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
      >
        {label == "ACTIVE"
          ? activeStatus === 1
            ? "ACTIVE"
            : "DEACTIVE"
          : label}
      </div>
    </div>
  );
}
